module.exports = __webpack_public_path__ + "static/media/error.9255ea27.png";